import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ata_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CHF = (n) =>
  new Intl.NumberFormat("fr-CH", { style: "currency", currency: "CHF" }).format(Number(n || 0));

export const PHONE_DISPLAY = "076 796 61 98";
export const PHONE_TEL = "+41767966198";
export const RESTAURANT = {
  name: "Asia Take Away",
  address: "Rue des Oliviers 1, 1018 Lausanne",
  phoneDisplay: PHONE_DISPLAY,
  phoneTel: PHONE_TEL,
};
